import axios, { axiosNL, axiosNT, axiosNTL } from '../../../services/axios';
import { GoalDescriptionBody } from '../types/GoalDescriptionBody';
import {
    MasterChapter,
    MasterConcept,
    MasterSubSubject,
    MasterSubject,
    MasterClass,
    MasterType,
    CodeInitials,
} from '../types/GoalManagementMasterBody'
import { CourseBody } from '../types/CourseBody';
import _ from 'lodash';
import contentService from '../../mylibrary/services/contentService';



const list = () => axiosNT.get('/course/getAllCourses/')
    .then((res: any) => {
        let goalManagementList: GoalDescriptionBody[] = res.responseObject;
        return Promise.resolve(goalManagementList);
    });
const goalList =(params:any) =>axiosNT.get('/course/course-types/',{ params })
.then((res:any)=>{
        return res.responseObject
})
const deletedGoalList = () => axiosNT.get('/course/getAllCourses?Archive=true')
    .then((res: any) => {
        let goalManagementList: GoalDescriptionBody[] = res.responseObject;
        return Promise.resolve(goalManagementList);
    });

const handleCourseImageUpload = async (
    attachment: File,
) => {
    try {
        const response = await contentService.generatePresignedUrl({
        key: attachment.name,
        location: "courseTypeImages",
        contentType: attachment.type
        });
        const {
        data: { fields, url },
        } = response;
        const { key } = fields;
    
        await contentService.uploadAttachment({
        file: attachment,
        uploadUrl: url,
        s3Fields: {'Content-Type': attachment.type, ...fields},
        });
    
        return `${url}/${key}`;
    } catch (error) {
        throw error;
    }
    };

const createGoal = (formData: any) => axios.post('/course/createCourse', formData)
    .then((res: any) => {
        let goalManagement: GoalDescriptionBody = res;
        return Promise.resolve(goalManagement);
    })

const updateGoal = (newData: any) => axios.post('/course/updateGoalName', newData)
    .then((res: any) => {
        let goalManagement: any = res;
        return Promise.resolve(goalManagement);
    })

const updateGoalVersion = (newData: any) =>{ 
    const groupId = newData.groupId;
    delete newData.groupId;
    return axios.patch(`/course/updateGoal/${groupId}`, newData)
    .then((res: any) => {
        let goalManagement: any = res;
        return Promise.resolve(goalManagement);
    })
}

const deleteGoalVersion = (formData: any) =>
  axios.post("/course/createCourse", formData).then((res: any) => {
    let goalManagement: GoalDescriptionBody = res.responseObject;
    return Promise.resolve(goalManagement);
  });

const duplicateGoalVersion = (newData: any) =>
  axios.post("/course/updateGoalName", newData).then((res: any) => {
    let goalManagement: any = res.responseObject;
    return Promise.resolve(goalManagement);
  });

const fetchMasterClass = () => (
    axiosNTL.get('/class/classList')
        .then((res: any) => {
            let classList: MasterClass[] = res.data;
            return Promise.resolve(classList);
        })
)

const fetchMasterSubject = (classId: string = "") => (
    axiosNTL.post(`/subject/getMasterSubject?classId=${classId}`)
        .then((res: any) => {
            let subjectList: MasterSubject[] = res.responseObject;
            return Promise.resolve(subjectList);
        })
)

const fetchMasterCountSubject = (classId: string = "", courseId?: string) => {
    let queryParams = `?classId=${classId}`
    if(courseId){
        queryParams += `&courseId=${courseId}`
    }
    return axiosNTL.get(`/subject/getCountMasterSubject${queryParams}`)
        .then((res: any) => {
            let subjectList: MasterSubject[] = res.responseObject;
            return Promise.resolve(subjectList);
        })
}

const fetchMasterSubSubject = (subjectId: string, classId: string = "", courseId?: string) => {
    let queryParams = `?classId=${classId}`
    if(courseId){
        queryParams += `&courseId=${courseId}`
    }
    return axiosNTL.get(`/subSubject/bySubjectId/${subjectId}${queryParams}`)
        .then((res: any) => {
            let subSubjectList: MasterSubSubject[] = res.responseObject ? res.responseObject : res.data
            return Promise.resolve(subSubjectList);
        })
}

const fetchMasterChapter = (subSubjectId: string, classId: string = "",courseId?: string) => {
    let queryParams = `?classId=${classId}`
    if(courseId){
        queryParams += `&courseId=${courseId}`
    }
    return axiosNTL.get(`/chapter/bySubSubjectId/${subSubjectId}${queryParams}`)
        .then((res: any) => {
            let chapterList: MasterChapter[] = res.responseObject ? res.responseObject : res.data
            return Promise.resolve(chapterList);
        })
}

const fetchMasterConcept = (chapterId: string, classId: string = "", courseId?: string) => {
    let queryParams = `?chapterId=${chapterId}&classId=${classId}`
    if(courseId){
        queryParams += `&courseId=${courseId}`
    }
    return axiosNTL.get(`/concept/conceptListByChapter${queryParams}`)
        .then((res: any) => {
            let conceptList: MasterConcept[] = res.responseObject ? res.responseObject : res.data
            return Promise.resolve(conceptList);
        })
}

const fetchCourseByGroupId = (courseId: String) => (
    axiosNTL.get(`/course/getCourseByGroupId/${courseId}`)
        .then((res: any) => {
            let courseGroup: CourseBody[] = res.responseObject;
            return Promise.resolve(courseGroup);
        })
)
const getCourseDetails = (courseId: string) =>
    axiosNT.get(`/course/getCourse/${courseId}`).then((res: any) =>
        Promise.resolve(res.responseObject)
    )


const saveCourseSyllabus = (formBody: any) => (
    axios.post('/courseSyllabus', formBody)
        .then((res: any) => {
            let response: any = res.responseObject;
            return Promise.resolve(response);
        })
)

const archiveCourse = (_id: any, params?: string) => {
    let queryParams = ''
    if(params){
        queryParams += `?${params}`
    }
    return axios.patch(`/course/archiveCourse/${_id}${queryParams}`)
        .then((res: any) => {
            let response: any = res.responseObject;
            return Promise.resolve(response);
        })
}

const deleteCourseSyllabus = (formBody: any) => (
    axiosNT.post('/courseSyllabus', formBody)
        .then((res: any) => {
            let response: any = res.responseObject;
            return Promise.resolve(response);
        })
)

const getCourseData = (courseId: string) => (
    axiosNT.get(`/courseSyllabus/getAllCourseSyllabus/${courseId}`)
        .then((res: any) => {
            let response: any = res.responseObject;
            return Promise.resolve(response);
        })
)

const publishGoal = (reqBody: any) => (
    axios.post('/courseSyllabus/publishCourse', reqBody)
        .then((res: any) => {
            let response: any = res.responseObject;
            return Promise.resolve(response);
        })
);

const addLocalMaster = (reqBody: any) => {
    return axios.post('/courseSyllabus/createLocalEntry', reqBody)
        .then((res: any) => {
            let response: any = res.responseObject;
            return Promise.resolve(response);
        })
}

const getLocalEntry = (courseId: string, parentId: string) => {
    return axios.get(`/courseSyllabus/getLocalEntry?courseId=${courseId}&parentId=${parentId}`)
        .then((res: any) => {
            let response: any = res.responseObject;
            return Promise.resolve(response);
        })
}

const mapCourses = (reqBody: any) => {
    return axios.post('/courseSyllabus/mapContent', reqBody)
        .then((res: any) => {
            let response: any = res.responseObject;
            return Promise.resolve(response);
        })
}

const syncAndNext = (parentId: string, localData: any, courseData: any, groupId: any, courseId: any) => {
    //NOTE:We are storing parentId in window object so that we can check whether we have prossed them early
    let tempParent: any = sessionStorage.getItem('processedParent');
    let url: any = `/goal-management/edit/${groupId}#${courseId}`;

    let temp: any = [];
    if (_.isNull(tempParent)) {
        tempParent = [parentId];
    } else {
        tempParent = JSON.parse(tempParent);
        tempParent.push(parentId);
    }

    if (!_.isEmpty(tempParent) && !_.isEmpty(localData)) {
        MasterType.forEach((mT: any) => {
            if (_.isEmpty(temp)) {
                temp = localData.filter((k: any) => k && !tempParent.includes(k.parent) && _.isEqual(mT, k.type));
            }
        });

    }
    sessionStorage.setItem('processedParent', JSON.stringify(tempParent));
    if (!_.isEmpty(temp)) {
        let sampleRequest = _.get(temp, '0');
        let tempUrl = generateUrl(sampleRequest, courseData, groupId);
        url = _.isEmpty(tempUrl) ? url : tempUrl;
    }
    return url;

}

const generateUrl = (sampleRequest: any, courseData: any, groupId: any) => {
    let url = "";
    if (!_.isEmpty(sampleRequest)) {
        if(sampleRequest.parent.id){
           sampleRequest.parent = sampleRequest.parent.id;
        }

        let masterData = _.find(courseData, { '_id': sampleRequest.parent });
        let classes = courseData.find((cd: any) => cd.type == 'class' && sampleRequest.ancestors.includes(cd._id));

        let mastersId = masterData && _.get(masterData, 'masterIDs', []);
        if (mastersId.length == 0) {
            mastersId = ["noclass"];
        }
        const masterClassId = classes.masterIDs && classes.masterIDs.length ? `${classes.masterIDs.join(',')}`: 'nomasterclass'
        if (!_.isEmpty(mastersId)) {
            switch (sampleRequest.type) {
                case 'subject':
                    url = `/subject-mapping/${sampleRequest.parent}/${sampleRequest.courseId}/${mastersId.join(',')}/${groupId}`;
                    break;
                case 'sub-subject':
                    url = `/sub-subject-mapping/${sampleRequest.parent}/${sampleRequest.courseId}/${masterClassId}/${mastersId.join(',')}/${groupId}`;
                    break;

                case 'chapter':
                    url = `/chapter-mapping/${sampleRequest.parent}/${sampleRequest.courseId}/${masterClassId}/${mastersId.join(',')}/${groupId}`;
                    break;

                case 'concept':
                    url = `/concept-mapping/${sampleRequest.parent}/${sampleRequest.courseId}/${masterClassId}/${mastersId.join(',')}/${groupId}`;
                    break;

                default:
                    url = '';
                    break;
            }
        }
        return url;
    }
}

const getSyllabusByMaster = (masterID: string) => {
    return axiosNT.get(`/courseSyllabus/getSyllabusByMaster/${masterID}`)
        .then((r: any) => r.responseObject)
}

const generateUniqueCode = (courseData: any, ancestors: any[], currentIndex: any, codeType: string) => {

    let initial: any = {
        "class": "",
        "subject": "",
        "sub-subject": "",
        "chapter": "",
        "concept": ""
    }
    let conceptCode: string = `${CodeInitials[codeType]}`;


    if (_.isArray(courseData)) {
        courseData && courseData.forEach((cd: any) => {
            if (ancestors.map((an: any)=> an.id).includes(cd._id)) {
                let orderNo = "";
                //INFO:Incase of class we need name and for rest we need index
                if (cd.type == 'class') {
                    orderNo = cd.name;
                } else {
                    orderNo = cd.orderNo < 10 ? `0${cd.orderNo}` : cd.orderNo;
                }
                initial[cd.type] = orderNo;
            }
        });

        Object.keys(initial).forEach((k: any) => {
            if (!_.isEmpty(initial[k])) {
                conceptCode += initial[k];
            }
        });

    }

    //Info:Incase of subject and class we don't have ancestors id;
    if (['subject'].includes(codeType)) {
        conceptCode += ancestors[0].orderNo;
    }

    conceptCode += currentIndex < 10 ? `0${currentIndex}` : currentIndex;


    return conceptCode;
}

const updateCourse = (reqBody: any) => (
    axiosNTL.post('/courseSyllabus/updateCourse', reqBody)
        .then((res: any) => {
            let response: any = res.responseObject;
            return Promise.resolve(response);
        })
);


const getMasters = (reqBody: any) => {
    return axiosNT.post(`/courseSyllabus/getMasters`, reqBody)
        .then((r: any) => r.responseObject)
}


const replaceInMaster = (reqBody: any) => {
    return axios.post(`/courseSyllabus/replaceInMaster`, reqBody)
        .then((r: any) => r)
}

const exportMasterCodeList = (courseId : string) => {
    return  axiosNTL.get(`/coursesyllabus/getCourseSyllabusListById/${courseId}`)
        .then((res: any) => {
            let masterCodeList: any = res.responseObject;
            return Promise.resolve(masterCodeList);
        })
}

const getGoalLevels = (queryParams: any) => {
    
    return axiosNTL.get(`/goal-level`, { params: queryParams })
        .then((r: any) => r.responseObject)
}
const addCareer = (reqBody: any) => {
    return axiosNL.post('/career', reqBody).then((r: any) => r);
}

const getCareerTypes = (reqBody: any) => {
    return axiosNTL.get('/career/careers', reqBody).then((res: any) => {
        return res.responseObject.data;
    })
}

const getGoalCategory =(courseTypeId:any)=>{
     
    return axiosNTL.get(`/mypat-category/?courseTypeId=${courseTypeId}`).then((res:any)=>
     res.responseObject.data
    )
}
const addNewGoalCategory =(reqbody:any)=>{
     return axiosNL.post('/mypat-category/',reqbody).then((res:any)=> res)
}
export default {
    list,
    createGoal,
    fetchMasterSubject,
    fetchMasterCountSubject,
    fetchMasterSubSubject,
    fetchMasterChapter,
    fetchMasterConcept,
    fetchMasterClass,
    saveCourseSyllabus,
    fetchCourseByGroupId,
    getCourseData,
    publishGoal,
    addLocalMaster,
    getLocalEntry,
    mapCourses,
    updateGoal,
    deleteCourseSyllabus,
    syncAndNext,
    getSyllabusByMaster,
    generateUniqueCode,
    updateCourse,
    getMasters,
    replaceInMaster,
    archiveCourse,
    deletedGoalList,
    deleteGoalVersion,
    updateGoalVersion,
    duplicateGoalVersion,
    exportMasterCodeList,
    getGoalLevels,
    addCareer,
    getCareerTypes,
    getGoalCategory,
    addNewGoalCategory,
    goalList,
    getCourseDetails,
    handleCourseImageUpload
}